export enum AuditEventType {
  APPROVE = 'APPROVE',
  COMMENT = 'COMMENT',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  DOCUMENT_ADD_TAG = 'DOCUMENT_ADD_TAG',
  DOCUMENT_REMOVE_TAG = 'DOCUMENT_REMOVE_TAG',
  DOCUMENT_STORE_ADD_DOCUMENT = 'DOCUMENT_STORE_ADD_DOCUMENT',
  DOCUMENT_STORE_DELETE_DOCUMENT = 'DOCUMENT_STORE_DELETE_DOCUMENT',
  EMAIL_FILTER_CREATED = 'EMAIL_FILTER_CREATED',
  EMAIL_FILTER_UPDATED = 'EMAIL_FILTER_UPDATED',
  EMAIL_FILTER_DELETED = 'EMAIL_FILTER_DELETED',
  EMAIL_CATEGORIZED = 'EMAIL_CATEGORIZED',
  EMAIL_FILTER_APPLIED = 'EMAIL_FILTER_APPLIED',
  MARKED_AS_REVIEWED = 'MARKED_AS_REVIEWED',
  UNMARKED_AS_REVIEWED = 'UNMARKED_AS_REVIEWED',
  ESCALATE = 'ESCALATE',
  EXPORT = 'EXPORT',
  FEEDBACK_IGNORE = 'FEEDBACK_IGNORE',
  FEEDBACK_RESOLVE = 'FEEDBACK_RESOLVE',
  FEEDBACK_ACKNOWLEDGE = 'FEEDBACK_ACKNOWLEDGE',
  LINK = 'LINK',
  LOG_IN = 'LOG_IN',
  LOG_OUT = 'LOG_OUT',
  SIGN_UP = 'SIGN_UP',
  AUTH_FAILED = 'AUTH_FAILED',
  POLICY_COPY = 'POLICY_COPY',
  POLICY_MOVE = 'POLICY_MOVE',
  POLICY_TEST = 'POLICY_TEST',
  REJECT = 'REJECT',
  SYNC = 'SYNC',
  UPDATE = 'UPDATE',
  UPLOAD = 'UPLOAD',
  VIEW = 'VIEW',
  SELECT = 'SELECT',
}

export enum AuditLogFeature {
  ANNOTATION = 'ANNOTATION',
  ATTRIBUTE = 'ATTRIBUTE',
  BRAND = 'BRAND',
  CLAIM = 'CLAIM',
  CLAIMS_APPROVAL_TASK = 'CLAIMS_APPROVAL_TASK',
  CLAIMS_APPROVAL_TASK_DOCUMENT = 'CLAIMS_APPROVAL_TASK_DOCUMENT',
  CLAIMS_APPROVAL_TASKS = 'CLAIMS_APPROVAL_TASKS',
  CONTENT_SCANNER = 'CONTENT_SCANNER',
  CONTENT_SCANNER_JOB = 'CONTENT_SCANNER_JOB',
  CONTENT_SCANNER_JOBS = 'CONTENT_SCANNER_JOBS',
  CONTENT_SCANNER_PAGE = 'CONTENT_SCANNER_PAGE',
  CONTENT_SCANNER_REPORT = 'CONTENT_SCANNER_REPORT',
  DECISION_STORE = 'DECISION_STORE',
  DOCUMENTS = 'DOCUMENTS',
  DOCUMENTS_FILE = 'DOCUMENTS_FILE',
  EMAIL_FILTERS = 'EMAIL_FILTERS',
  EVALUATION_TYPE = 'EVALUATION_TYPE',
  FEEDBACK = 'FEEDBACK',
  FEEDBACK_LABEL = 'FEEDBACK_LABEL',
  FILE_AIRTABLE = 'FILE_AIRTABLE',
  FILE_GOOGLE = 'FILE_GOOGLE',
  FEEDBACK_SUGGESTION = 'FEEDBACK_SUGGESTION',
  INFLUENCER_MONITORING = 'INFLUENCER_MONITORING',
  INFLUENCER_MONITORING_JOB = 'INFLUENCER_MONITORING_JOB',
  INFLUENCER_MONITORING_JOBS = 'INFLUENCER_MONITORING_JOBS',
  INFLUENCER_MONITORING_POST = 'INFLUENCER_MONITORING_POST',
  LOG = 'LOG',
  MARKETING_TASK = 'MARKETING_TASK',
  MARKETING_TASK_DOCUMENT = 'MARKETING_TASK_DOCUMENT',
  MARKETING_TASKS = 'MARKETING_TASKS',
  POLICY = 'POLICY',
  POLICY_GROUP = 'POLICY_GROUP',
  REMEDIATION_TASK = 'REMEDIATION_TASK',
  REMEDIATION_TASK_DOCUMENT = 'REMEDIATION_TASK_DOCUMENT',
  REMEDIATION_TASKS = 'REMEDIATION_TASKS',
  TAG = 'TAG',
  TRADEMARK = 'TRADEMARK',
  USER_INVITATION = 'USER_INVITATION',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  USER_ROLE = 'USER_ROLE',
  WORKSPACE = 'WORKSPACE',
  AGENT_MODEL = 'AGENT_MODEL',
  COMMENT = 'COMMENT',
  ARCHIVE_QUEUE = 'ARCHIVE_QUEUE',
  ASSISTANT_THREAD = 'ASSISTANT_THREAD',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SHAREABLE_LINK = 'SHAREABLE_LINK',
}
